import { FunctionComponent } from "react";
import {
  Logo,
  StyledFooter,
  StyledInnerContainer,
  StyledLeftCol,
  StyledContainerRow,
  StyledRightCol,
} from "./footer.styles";
import timberLogoText from "images/timber-logo-text.png";
import moment from "moment";

const Footer: FunctionComponent = () => {
  return (
    <StyledFooter wide>
      <StyledInnerContainer>
        <StyledContainerRow>
          <StyledLeftCol>
            <Logo src={timberLogoText} alt="" />{" "}
          </StyledLeftCol>
          <StyledRightCol>
            © {moment().year()}
            {" - "}
            <a href="mailto:support@timbergrades.com">
              support@timbergrades.com
            </a>
          </StyledRightCol>
        </StyledContainerRow>
      </StyledInnerContainer>
    </StyledFooter>
  );
};

export default Footer;
